// @ts-check
import { Flex, Padding } from 'components/base/layout-components';
import styled from 'styled-components';
import NewSlackAccount from 'images/new-slack-account.svg';
import Text from 'components/base/Text';
import language from 'common/language/en.lang';
import { LBButton } from '@linearb/buzz';

const { approveButton } = language.Setting.Slack.reauthorize.newConnectionModal;

const { cancel } = language.General;

const StyledSVG = styled.img`
  width: 25rem;
  display: block;
  margin: 2rem auto 0 auto;
`;

const StyledSpan = styled.span`
  font-weight: bold;
`;

const NewConnectionModalContentWrapper = styled(Flex)`
  padding-top: 0 !important;
`;

const ModalTitle = styled(Text)`
  font-size: 2rem;
`;

const NewConnectionModal = ({
  onSubmit,
  onCancel,
  newTeamName,
  oldTeamName
}) => {
  return (
    <Flex direction='column' justify='space-between' padding='medium' pt='0'>
      <StyledSVG src={NewSlackAccount} />
      <NewConnectionModalContentWrapper direction='column' padding='medium'>
        <ModalTitle weight='400'>
          Would you like to replace your current Slack workspace with: "
          {newTeamName}"?
        </ModalTitle>
        <Text weight='400' size='large' mt='1.8rem' lineHeight='2.4rem'>
          You are currently connected to Slack workspace: "{oldTeamName}"
          <br />
          Connecting a new account will{' '}
          <StyledSpan>remove Slack settings for all your teams</StyledSpan> and
          you will need to configure them from scratch.
          <br />
        </Text>
        <Text weight='400' size='large' mt='1.8rem' lineHeight='2.4rem'>
          Please contact support and we’ll help you with the changes
        </Text>
        <Flex direction='row-reverse' mt='medium'>
          <Padding l='small'>
            <LBButton onClick={onSubmit}>{approveButton()}</LBButton>
          </Padding>
          <LBButton variant='outline' onClick={onCancel}>
            {cancel()}
          </LBButton>
        </Flex>
      </NewConnectionModalContentWrapper>
    </Flex>
  );
};

export default NewConnectionModal;
